import { render, staticRenderFns } from "./DashboardStatistics.vue?vue&type=template&id=79cf11e6&scoped=true&"
import script from "./DashboardStatistics.vue?vue&type=script&lang=ts&"
export * from "./DashboardStatistics.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardStatistics.vue?vue&type=style&index=0&id=79cf11e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79cf11e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCol,VIcon,VRow,VSelect,VSkeletonLoader})
